import React, { useEffect, useState } from "react";
import "./App.css";

function parseLinks(text) {
  
  return text
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l && !l.startsWith("#"))
    .map((line) => {
      let name = "";
      let url = "";

      if (line.includes(":")) {
        const parts = line.split(":");
        name = parts.shift().trim();
        url = parts.join(":").trim(); 
      } else if (line.includes(" - ")) {
        const parts = line.split(" - ");
        name = parts[0].trim();
        url = parts[1].trim();
      } else if (line.includes("|")) {
        const parts = line.split("|");
        name = parts[0].trim();
        url = parts[1].trim();
      } else {
        
        const i = line.indexOf("http");
        if (i !== -1) {
          name = line.slice(0, i).replace(/[:\-\s]+$/, "").trim();
          url = line.slice(i).trim();
        } else {
          
          url = line;
          name = line;
        }
      }

      if (!name) name = url;
      return { name, url };
    });
}

export default function App() {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    const fetchLinks = async () => {
      setLoading(true);
      setErr(null);
      try {
        // relative path to public/links.txt; add cache-buster so browser fetches new file after replace
        const url = `${process.env.PUBLIC_URL || ""}/links.txt?ts=${Date.now()}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error("Failed to load links.txt (" + res.status + ")");
        const txt = await res.text();
        const parsed = parseLinks(txt);
        setLinks(parsed);
      } catch (e) {
        console.error(e);
        setErr(e.message);
        setLinks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLinks();
  }, []);

  return (
    <div className="app">
      {/* <h1 className="section-title">
          <center>This website is currently undergoing enhancements. Please check back later.</center>
        </h1> */}
      <div className="layout">
        <div className="info">
          <h1 className="title">
            RAN ONLINE EP4: <span className="accent">DARKNESS</span>
          </h1>

          <h2 className="section-title">Server Information</h2>

          <div className="info-grid">
            <ul>
              <li>4 Class Balance Character</li>
              <li>1 Hit / Synch Gaming / Combo Based Server</li>
              <li>Max Level: 175/157</li>
              <li>Drop Rate: Low EXP</li>
              <li>Rate: High EXP</li>
              <li>Auto Learn Skill</li>
              <li>Open Map LVL Required</li>
            </ul>
            <ul>
              <li>PvP Wars: </li>
              <li>Tyranny Wars</li>
              <li>Clubs Wars</li>
              <li>Red VS Blue</li>
              <li>School Wars</li>
              <li>War Of the Emperium</li>
            </ul>
          </div>

          <p className="owners">
            <strong>Server Owners:</strong><br /> <a href="https://www.facebook.com/michael.rosellosa24" target="_blank">Michael Dablo Rosellosa</a> / TitoMaikee <br /> <a href="https://www.facebook.com/dhan013" target="_blank">Dhan Antonio Mota</a> /
            Styx
          </p>

          <p className="owners">
            <strong>Partners:</strong><br /> Developer: <a href="https://www.facebook.com/profile.php?id=61576063935705" target="_blank">MDZ Development</a> <br /> Editor: <a href="https://www.facebook.com/GhostWorksByAtlastStudio" target="_blank">GHOST WORKS by: Atlast Studio</a> 
          </p>

          <p className="owners">
            <strong>Community:</strong><br /> FB Group: <a href="https://www.facebook.com/groups/ranonlineep4darkness" target="_blank">Ran Online Ep4 : Darkness OFFICIAL GROUP</a> <br /> FB Page: <a href="https://www.facebook.com/RanOnlineDARKNESSep4" target="_blank">Ran Online Ep4 : Darkness</a> 
          </p>

          <div className="downloads">
            <h3 className="section-title">Download Links</h3>

            {loading && <p className="muted">Loading links…</p>}
            {err && <p className="error">Error loading links: {err}</p>}
            {!loading && !err && links.length === 0 && (
              <p className="muted">No links found. Edit <code>public/links.txt</code>.</p>
            )}

            <div className="btn-row">
              {links.map((l, i) => (
                <a
                  key={i}
                  className="download-btn"
                  href={l.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {l.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT: Poster */}
        <div className="poster">
          <img
            src={`${process.env.PUBLIC_URL || ""}/darkness_logo.png`}
            alt="Darkness Ran Poster"
            onError={(e) => {
              // helpful fallback if image missing
              e.currentTarget.style.display = "none";
            }}
          />
        </div>
      </div>

      {/* <footer className="footer">
        Update <code>public/links.txt</code> in the published folder to change download links (no rebuild).
      </footer> */}

        <div className="perks">
          <h1 className="section-title">Darkness Perks</h1>
          
          <div className="perk-row">
            <div className="perk-group">
              <h3 className="perk-title">Solo Perks</h3>
              <ul>
                <li>Set Costumes</li>
                <li>Weapon Costumes</li>
                <li>Headgear Costumes</li>
              </ul>
            </div>

            <div className="perk-group">
              <h3 className="perk-title">Streamer Perks</h3>
              <ul>
                <li>Set Costumes</li>
                <li>Weapon Costumes</li>
                <li>And more!</li>
              </ul>
            </div>

            <div className="perk-group">
              <h3 className="perk-title">GL/ Commander Perks</h3>
              <ul>
                <li>Set Costumes</li>
                <li>Weapon Costumes</li>
                <li>And more!</li>
              </ul>
            </div>

            <div className="perk-group">
              <h3 className="perk-title">FS Perks</h3>
              <ul>
                <li>Set Costumes</li>
                <li>Weapon Costumes</li>
                <li>And more!</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="perks">
          <div className="perk-row">
            <div className="poster">
              <img
                src={`${process.env.PUBLIC_URL || ""}/server_owner.png`}
                alt="Darkness Ran Poster"
                onError={(e) => {
                  // helpful fallback if image missing
                  e.currentTarget.style.display = "none";
                }}
              />
            </div>
          </div>
        </div>

        <div className="perks">
          <div className="perk-row">
            <div className="poster">
              <img
                src={`${process.env.PUBLIC_URL || ""}/partners.png`}
                alt="Darkness Ran Poster"
                onError={(e) => {
                  // helpful fallback if image missing
                  e.currentTarget.style.display = "none";
                }}
              />
            </div>
          </div>
        </div>

    </div>

  );
}
